import { Component, ElementRef } from '@angular/core';

@Component({
    selector: 'al-overlay',
    template: `
        <div></div>
    `
})

export class AlOverlayComponent {

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     *
     */
    constructor(private _element: ElementRef) { }

    /**
     * offset method, getting elements top and left offset and width and height
     *
     * @method offset
     * @param el
     *
     */
    offset(el) {
        let rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft, width: rect.width, height: rect.height };
    }

    /**
     * showOverlayFn will create an overlay div and button and set offset as per refElement
     *
     * @method showOverlayFn
     * @param refElement
     *
     */
    showOverlayFn(refElement) {
        let overlayEleCreated = document.createElement('div');
        overlayEleCreated.classList.add('al-overlay-cover', refElement);

        overlayEleCreated.innerHTML = '<button type="button" class="al-button-positive ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only al-overlay-cover-hide"><span class="ui-button-text ui-clickable">Hide Overlay</span></button>';

        document.body.appendChild(overlayEleCreated);
        let overlayEle = document.querySelector('.' + refElement);
        (overlayEle as HTMLElement).style.display = 'block';
        let getRefElement = document.querySelector('#' + refElement);
        let getRefElementPos = this.offset(getRefElement);
        (overlayEle as HTMLElement).style.top = getRefElementPos.top + 'px';
        (overlayEle as HTMLElement).style.left = getRefElementPos.left + 'px';
        (overlayEle as HTMLElement).style.width = getRefElementPos.width + 'px';
        (overlayEle as HTMLElement).style.height = getRefElementPos.height + 'px';

        overlayEleCreated.querySelector('button').addEventListener('click', (event) => this.hideOverlayFn(event));
    }

    /**
     * hide overlay based on element param
     *
     * @method hideOverlayFn
     * @param element
     *
     */

    hideOverlayFn(element) {
        let overlayEle = event.currentTarget;
        (overlayEle as HTMLElement).parentElement.style.display = 'none';
    }
}
